export const validateCEP = (value) => new RegExp(/^\d{5}-\d{3}$/g).test(value)
